import React, { useContext, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import {
  LayoutDashboard,
  Users,
  ShieldCheck,
  Store,
  GitBranch,
  Warehouse,
  Package,
  Tags,
  Truck,
  Factory,
  BarChart3,
  ShoppingCart,
  Calculator,
  FileText,
  FileSearch,
  Receipt,
  Briefcase,
  UserPlus,
  FileCheck,
  ClipboardList,
  CalendarDays,
  CreditCard,
  UserCircle,
  Banknote,
  Scale,
  BadgeDollarSign,
  BriefcaseBusiness,
  Timer,
  Box,
  LayoutGrid,
  ChevronDown,
  ChevronRight,
  ClipboardCheck,
  UserCheck,
  History,
  Landmark
} from "lucide-react";
import { WarehouseContext } from "../../Utility/UserContext";
import { cn } from "../../lib/utils";

const Sidebar = ({ isVisible, toggleSidebar }) => {
  const location = useLocation();
  const { UserItem } = useContext(WarehouseContext);
  // Defining the nested menu items for Super Admin
  const menuItems = [
    { title: "Dashboard", url: "/dashboard", icon: LayoutDashboard },
    {
      title: "Companies",
      icon: BriefcaseBusiness,
      subItems: [
        { title: "Shops", url: "/sub-company", icon: Store },
        { title: "Branches", url: "/shops-branch", icon: GitBranch },
      ]
    },
    {
      title: "Suppliers",
      icon: Truck,
      subItems: [
        { title: "Supplier List", url: "/Supplier_list", icon: Truck },
        { title: "Supplier Credit", url: "/Supplier_receipt", icon: CreditCard },
      ]
    },
    {
      title: "Customers",
      icon: UserPlus,
      subItems: [
        { title: "Customer List", url: "/Customers_list", icon: UserPlus },
        { title: "Customer Credit", url: "/Customer_receipt", icon: CreditCard },
      ]
    },
    {
      title: "Raw Materials",
      icon: Factory,
      subItems: [
        { title: "Raw Materials", url: "/raw_materials", icon: Factory },
        { title: "RM History", url: "/raw_transection", icon: LayoutGrid },
        { title: "Purchase", url: "/purchase", icon: ShoppingCart },
        { title: "Raw Material Expiry", url: "/Rawmetrial_expiry", icon: History },
      ]
    },
    {
      title: "End Products",
      icon: Package,
      subItems: [
        { title: "Category", url: "/Category_list", icon: Tags },
        { title: "Product Master", url: "/product_master", icon: Package },
        { title: "Product Packs", url: "/Product_master_details", icon: Package },
        { title: "Product Process", url: "/e_product_process", icon: ClipboardCheck },
        { title: "Products History", url: "/product-detail-transaction", icon: BarChart3 },
        { title: "Undistributed Product", url: "/undistributed-products", icon: ClipboardList },
        { title: "Products Expire", url: "/product_expire", icon: History },
      ]
    },
    {
      title: "Inventory",
      icon: Box,
      subItems: [
        { title: "Units", url: "/units", icon: Scale },
        { title: "Taxes", url: "/taxes", icon: Calculator },
      ]
    },
    {
      title: "Sales",
      icon: ShoppingCart,
      subItems: [
        { title: "Sales Order", url: "/product_order", icon: ClipboardCheck },
        { title: "Sales List", url: "/sales_list", icon: FileSearch },
        { title: "Sales Return List", url: "/return_list_order", icon: ClipboardList },
        { title: "RM Sales Order", url: "/raw_material_order", icon: ClipboardCheck, hide: true },
        { title: "RM Sales List", url: "/rm_sales_list", icon: FileSearch, hide: true },
        { title: "RM Sales Return List", url: "/rm_return_list_order", icon: ClipboardList, hide: true },
      ]
    },
    /*
    {
      title: "Returns",
      icon: History,
      subItems: [
        { title: "Sales Return", url: "/return", icon: ClipboardCheck },
        { title: "Sales Return List", url: "/return_list_order", icon: ClipboardList },
        { title: "Purchase Return", url: "/purchase_return", icon: ShoppingCart },
        { title: "Purchase Return List", url: "/purchase-return-list", icon: Receipt },
      ]
    },
    */
    {
      title: "Purchases",
      icon: ShoppingCart,
      subItems: [
        { title: "Purchase List", url: "/purchase", icon: ShoppingCart },
        { title: "Purchase Return List", url: "/purchase-return-list", icon: Receipt },
      ]
    },
    { title: "Expense", url: "/expense", icon: Banknote },
    {
      title: "Accounts",
      icon: BarChart3,
      subItems: [
        { title: "Bank", url: "/bank", icon: Landmark },
        { title: "Trial & Balance", url: "/accounts_list", icon: BarChart3 },
        { title: "Capital", url: "/capital", icon: Banknote },
        { title: "Assets", url: "/assets", icon: Briefcase },
        { title: "General Ledger", url: "/general-ledger", icon: FileText },
        { title: "Profit/Loss Report", url: "/profitloss-report", icon: Calculator },
        { title: "Loan Report", url: "/loan-report", icon: BadgeDollarSign },
      ]
    },
    {
      title: "Employee Management",
      icon: Users,
      subItems: [
        { title: "Employees", url: "/user_list", icon: UserCircle },
        { title: "Salary Management", url: "/salary_list", icon: BadgeDollarSign },
        { title: "Advance Reports", url: "/advance_report", icon: History },
        { title: "Roles", url: "/Role_list", icon: ShieldCheck },
      ]
    },
    {
      title: "Share Holder",
      icon: UserCheck,
      subItems: [
        // { title: "Share Holders", url: "/shareholders", icon: UserCheck },
        { title: "Share Holders", url: "/share-holders", icon: UserCheck },
        { title: "ShareHolder Payments", url: "/share-holder-payment", icon: CreditCard },
      ]
    },
    {
      title: "Reports",
      icon: FileText,
      subItems: [
        { title: "Supplier Transaction", url: "/supplier-transaction", icon: BarChart3 },
        { title: "Customer Transaction", url: "/customr-transaction", icon: BarChart3 },
        { title: "Daily Transaction", url: "/all-transaction", icon: Timer },
        { title: "Sales Report", url: "/sales_report", icon: ShoppingCart },
        { title: "Purchase Report", url: "/purchase-report", icon: Receipt },
        { title: "Raw Material Report", url: "/raw-material-report", icon: Factory },
        { title: "Finished Product Report", url: "/finished-product-report", icon: Package },
        { title: "Salary Report", url: "/salary_list", icon: BadgeDollarSign },
        { title: "Profit Loss Batch Report", url: "/pobatch-report", icon: ClipboardList },
      ]
    },
  ];

  const [openSubmenus, setOpenSubmenus] = useState(() => {
    const initialState = {};
    menuItems.forEach(item => {
      if (item.subItems?.some(sub =>
        location.pathname === sub.url || sub.subItems?.some(ss => location.pathname === ss.url)
      )) {
        initialState[item.title] = true;
      }
      item.subItems?.forEach(sub => {
        if (sub.subItems?.some(ss => location.pathname === ss.url)) {
          initialState[sub.title] = true;
        }
      });
    });
    return initialState;
  });

  const isActive = (url) => location.pathname === url;

  const toggleSubmenu = (name) => {
    setOpenSubmenus(prev => ({
      ...prev,
      [name]: !prev[name]
    }));
  };

  const rolePermissions = UserItem?.menu_list ? JSON.parse(UserItem.menu_list) : [];

  const hasPermission = (item) => {
    if (item.hide) return false;
    const role = UserItem?.role_title?.toLowerCase();
    const isAdminOrSuper = role === "super admin" || role === "admin";
    if (isAdminOrSuper) return true;

    if (item.title === "Returns") return false;

    // Parent group visibility based on RBAC checkboxes
    if (item.title === "End Products") {
      return rolePermissions.some(r => r.menu === "/Product_list");
    }
    if (item.title === "Raw Materials") {
      return rolePermissions.some(r => r.menu === "/raw_metrial");
    }
    if (item.title === "Customers") {
      return rolePermissions.some(r => r.menu === "/Customers_list");
    }
    if (item.title === "Suppliers") {
      return rolePermissions.some(r => r.menu === "/Supplier_list");
    }
    if (item.title === "Accounts") {
      return rolePermissions.some(r => r.menu === "/accounts");
    }
    if (item.title === "Sales") {
      return rolePermissions.some(r => r.menu === "/product_order" || r.menu === "/sales_list");
    }
    if (item.title === "Purchases") {
      return rolePermissions.some(r => r.menu === "/purchase");
    }
    if (item.title === "Employee Management") {
      return rolePermissions.some(r => r.menu === "/User_list" || r.menu === "/Role_list");
    }

    if (item.url) {
      if (item.url === "/dashboard") return true;

      // Raw Materials routes inheriting from "/raw_metrial"
      const rawMaterialsRoutes = ["/raw_materials", "/raw_transection", "/Rawmetrial_expiry"];
      if (rawMaterialsRoutes.includes(item.url)) {
        return rolePermissions.some(r => r.menu === "/raw_metrial");
      }

      // Customer routes inheriting from "/Customers_list"
      if (item.url === "/Customer_receipt") {
        return rolePermissions.some(r => r.menu === "/Customers_list");
      }

      // Supplier routes inheriting from "/Supplier_list"
      if (item.url === "/Supplier_receipt") {
        return rolePermissions.some(r => r.menu === "/Supplier_list");
      }

      // Accounts routes inheriting from "/accounts"
      const accountsRoutes = ["/bank", "/accounts_list", "/capital", "/assets", "/general-ledger", "/profitloss-report", "/loan-report"];
      if (accountsRoutes.includes(item.url)) {
        return rolePermissions.some(r => r.menu === "/accounts");
      }

      // Sales routes inheritance
      if (item.url === "/raw_material_order") {
        return rolePermissions.some(r => r.menu === "/product_order");
      }
      const salesListRoutes = ["/rm_sales_list", "/return_list_order", "/rm_return_list_order"];
      if (salesListRoutes.includes(item.url)) {
        return rolePermissions.some(r => r.menu === "/sales_list");
      }

      // Purchase routes inheritance
      if (item.url === "/purchase-return-list") {
        return rolePermissions.some(r => r.menu === "/purchase");
      }

      // Employee Management routes inheritance / case correction
      if (item.url === "/user_list") {
        return rolePermissions.some(r => r.menu === "/User_list");
      }

      // End Products sub-routes inheriting from "/Product_list"
      const productSubRoutes = [
        "/product_master",
        "/Product_master_details",
        "/e_product_process",
        "/product-detail-transaction",
        "/undistributed-products",
        "/product_expire"
      ];
      if (productSubRoutes.includes(item.url)) {
        return rolePermissions.some(r => r.menu === "/Product_list");
      }

      // Fallback direct URL check
      return rolePermissions.some(r => r.menu === item.url);
    }

    if (item.subItems) {
      return item.subItems.some(sub => hasPermission(sub));
    }
    return false;
  };

  const visibleItems = menuItems.filter(hasPermission);

  return (
    <aside className={cn(
      "fixed inset-y-0 left-0 z-50 w-64 bg-white border-r border-slate-100 flex flex-col transition-all duration-300 shadow-xl md:shadow-none overflow-hidden",
      isVisible ? "translate-x-0" : "-translate-x-full"
    )}>
      {/* Sidebar Header */}
      <div className="p-4 border-b border-slate-50 flex items-center gap-3 bg-white">
        <img
          src="/assets/images/ztr_masala_logo.jpg"
          alt="ZTR Masala Logo"
          className="w-9 h-9 rounded-lg shadow-sm object-cover"
        />
        <div className="flex flex-col">
          <span className="font-bold text-[#0f172a] text-sm leading-tight tracking-tight">ZTR Masala</span>
          <span className="text-[10px] font-medium text-slate-400">Inventory ERP</span>
        </div>
      </div>

      {/* Sidebar Content */}
      <div className="flex-1 overflow-y-auto py-4 px-3 space-y-1 scrollbar-thin scrollbar-thumb-slate-200">
        {visibleItems.map((item) => (
          <div key={item.title}>
            {item.subItems ? (
              <div className="space-y-1">
                <button
                  onClick={() => toggleSubmenu(item.title)}
                  className={cn(
                    "w-full flex items-center justify-between px-3 py-2.5 rounded-lg text-[13px] font-medium transition-all duration-200",
                    (openSubmenus[item.title] || item.subItems.some(sub => isActive(sub.url)))
                      ? "text-blue-600 bg-blue-50/50"
                      : "text-slate-700 hover:bg-slate-100 hover:text-slate-900"
                  )}
                >
                  <div className="flex items-center gap-3 flex-1 min-w-0">
                    <item.icon className="w-[18px] h-[18px] shrink-0" />
                    <span className="truncate whitespace-nowrap text-[13px]">{item.title}</span>
                  </div>
                  <div className="shrink-0 ml-2">
                    {openSubmenus[item.title] ? (
                      <ChevronDown className="w-3.5 h-3.5" />
                    ) : (
                      <ChevronRight className="w-3.5 h-3.5" />
                    )}
                  </div>
                </button>

                {openSubmenus[item.title] && (
                  <div className="ml-4 pl-4 border-l border-slate-100 space-y-1 mt-1 animate-in slide-in-from-top-1 duration-200">
                    {item.subItems.filter(hasPermission).map((sub) => (
                      <React.Fragment key={sub.title}>
                        {sub.subItems ? (
                          <div className="space-y-1">
                            <button
                              onClick={(e) => {
                                e.preventDefault();
                                toggleSubmenu(sub.title);
                              }}
                              className={cn(
                                "w-full flex items-center justify-between px-3 py-2 rounded-md text-[13px] font-medium transition-all duration-200",
                                (openSubmenus[sub.title] || sub.subItems.some(ss => isActive(ss.url)))
                                  ? "text-blue-600 bg-blue-50/50"
                                  : "text-slate-600 hover:text-slate-900 hover:bg-slate-50"
                              )}
                            >
                              <div className="flex items-center gap-3">
                                <sub.icon className="w-[18px] h-[18px]" />
                                <span>{sub.title}</span>
                              </div>
                              {openSubmenus[sub.title] ? (
                                <ChevronDown className="w-3 h-3" />
                              ) : (
                                <ChevronRight className="w-3 h-3" />
                              )}
                            </button>
                            {openSubmenus[sub.title] && (
                              <div className="ml-3 pl-3 border-l border-slate-50 space-y-1 mt-1">
                                {sub.subItems.filter(hasPermission).map((ss) => (
                                  <Link
                                    key={ss.title}
                                    to={ss.url}
                                    onClick={() => window.innerWidth < 768 && toggleSidebar()}
                                    className={cn(
                                      "flex items-center gap-3 px-3 py-1.5 rounded-md text-[12px] font-medium transition-all duration-200",
                                      isActive(ss.url)
                                        ? "text-blue-600 bg-blue-50 font-bold"
                                        : "text-slate-500 hover:text-slate-700 hover:bg-slate-50"
                                    )}
                                  >
                                    <ss.icon className="w-[18px] h-[18px]" />
                                    <span>{ss.title}</span>
                                  </Link>
                                ))}
                              </div>
                            )}
                          </div>
                        ) : (
                          <Link
                            to={sub.url}
                            onClick={() => window.innerWidth < 768 && toggleSidebar()}
                            className={cn(
                              "flex items-center gap-3 px-3 py-2 rounded-md text-[13px] font-medium transition-all duration-200",
                              isActive(sub.url)
                                ? "text-blue-600 bg-blue-50 font-bold"
                                : "text-slate-600 hover:text-slate-900 hover:bg-slate-50"
                            )}
                          >
                            <sub.icon className="w-[18px] h-[18px]" />
                            <span>{sub.title}</span>
                          </Link>
                        )}
                      </React.Fragment>
                    ))}
                  </div>
                )}
              </div>
            ) : (
              <Link
                to={item.url}
                onClick={() => window.innerWidth < 768 && toggleSidebar()}
                className={cn(
                  "flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-all duration-200",
                  isActive(item.url)
                    ? "bg-blue-600 text-white shadow-md shadow-blue-100 translate-x-1"
                    : "text-slate-700 hover:bg-slate-100 hover:text-slate-900"
                )}
              >
                <item.icon className={cn(
                  "w-[18px] h-[18px] shrink-0",
                  isActive(item.url) ? "text-white" : "text-slate-500 group-hover:text-slate-700"
                )} />
                <span className="truncate whitespace-nowrap">{item.title}</span>
              </Link>
            )}
          </div>
        ))}
      </div>

      {/* Sidebar Footer */}
      <div className="p-4 border-t border-slate-100 bg-white">
        <div className="flex items-center gap-3 p-2 rounded-xl bg-slate-50 border border-slate-100">
          <div className="w-8 h-8 rounded-full bg-blue-100 flex items-center justify-center text-blue-600 text-xs font-bold uppercase">
            {UserItem?.full_name?.charAt(0) || "U"}
          </div>
          <div className="flex flex-col overflow-hidden">
            <span className="text-sm font-semibold text-slate-700 truncate">{UserItem?.full_name}</span>
            <span className="text-[10px] text-slate-400 font-medium truncate uppercase">{UserItem?.role_title}</span>
          </div>
        </div>
      </div>
    </aside>
  );
};

export default Sidebar;
